// biome-ignore lint/style/noRestrictedGlobals: encapsulation
export const { assign } = Object;
